var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"room-form"},[(_vm.isEditingInProgress)?_c('room-form-edit'):_c('room-form-create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }